import { Span, Snack } from "@tblabs/truffle";
import { CopyToClipboard } from "../Utils/CopyToClipboard";


export class CopiableText extends Span
{
    constructor(text: string)
    {
        super(text + " 📋");

        this.CursorPointer();

        this.OnClick(() =>
        {
            CopyToClipboard(text);
            new Snack("📋 Skopiowano do schowka", text, { autoCloseTimeout: 2000 });
        });
    }
}
